export const FORM_MAP_GET_REQUEST = 'FORM_MAP_GET_REQUEST';
export const FORM_MAP_GET_SUCCESS = 'FORM_MAP_GET_SUCCESS';
export const FORM_MAP_GET_ERROR = 'FORM_MAP_GET_ERROR';
export const FORM_MAP_GET_BY_KEY_REQUEST = 'FORM_MAP_GET_BY_KEY_REQUEST';
export const FORM_MAP_GET_BY_KEY_SUCCESS = 'FORM_MAP_GET_BY_KEY_SUCCESS';
export const FORM_MAP_GET_BY_KEY_ERROR = 'FORM_MAP_GET_BY_KEY_ERROR';
export const FORM_MAP_ADD_REQUEST = 'FORM_MAP_ADD_REQUEST';
export const FORM_MAP_ADD_SUCCESS = 'FORM_MAP_ADD_SUCCESS';
export const FORM_MAP_ADD_ERROR = 'FORM_MAP_ADD_ERROR';
export const FORM_MAP_EDIT_REQUEST = 'FORM_MAP_EDIT_REQUEST';
export const FORM_MAP_EDIT_SUCCESS = 'FORM_MAP_EDIT_SUCCESS';
export const FORM_MAP_EDIT_ERROR = 'FORM_MAP_EDIT_ERROR';
export const FORM_MAP_DELETE_REQUEST = 'FORM_MAP_DELETE_REQUEST';
export const FORM_MAP_DELETE_SUCCESS = 'FORM_MAP_DELETE_SUCCESS';
export const FORM_MAP_DELETE_ERROR = 'FORM_MAP_DELETE_ERROR';
